import { Clear, Search } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField, { StandardTextFieldProps } from '@mui/material/TextField';
import { FC } from 'react';

interface SimpleSearchFieldProps extends StandardTextFieldProps {
  search: string;
  setSearch: (newSearch: string) => void;
}

const SimpleSearchField: FC<SimpleSearchFieldProps> = ({ search, setSearch, ...props }) => {
  return (
    <TextField
      {...props}
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position='start'>
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position='end'>
              {search && (
                <IconButton size='small' onClick={() => setSearch('')}>
                  <Clear />
                </IconButton>
              )}
            </InputAdornment>
          )
        }
      }}
    />
  );
};

export default SimpleSearchField;
